// gatsby-browser.js

exports.onClientEntry = () => {
	// IntersectionObserver polyfill for gatsby-image (Safari, IE)
	if (typeof window.IntersectionObserver === `undefined`) {
		require(`intersection-observer`);
		console.log(`👍 IntersectionObserver is polyfilled`);
	}
};
